import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { cryptoDecrypt } from '@/utils/aes';
import { getBase64 } from '@/utils/validate';
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import { policyDetail, policyInsuredInfo, policyRendering, policyTempConfig, editPolicy } from './request';
import PalnModel from './../customerManage/planModel.vue';
import { uploadFile } from './../../customer/applicationManage/request';
import { mainPlanResource } from './../../insurance/insuranceManage/request';
import { policyVerifyy } from './../customerManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { mapState } from 'vuex';
export default {
  components: {
    topTitle,
    PalnModel,
    areaSelect
  },
  data() {
    return {
      action: uploadFile,
      palnShow: false,
      loading: false,
      form: {},
      policInfo: {},
      planList: [],
      fileList: [],
      applicantForm: {},
      applicantList: [],
      rendering: {},
      insuredList: [],
      previewImage: '',
      previewVisible: false,
      isShow: false,
      hasAttachInfo: false,
      attachOptions: [],
      attachValue: [],
      tableData: [],
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: 'name',
        width: '30%'
      }, {
        slots: {
          title: '保障额度'
        },
        dataIndex: 'amount',
        key: 'amount',
        width: '40%',
        scopedSlots: {
          customRender: 'amount'
        }
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'price',
        key: 'price',
        width: '30%',
        scopedSlots: {
          customRender: 'price'
        }
      }],
      //附加险信息表头信息
      insuredForm: {},
      applicantTypeTemOption: [],
      insuredTemplate: [],
      applicantInfo: {},
      rearOptions: [],
      isAreaPrice: false,
      codeValue: [],
      //区域保费的区域的回显值
      showPersonnelDetail: false,
      showRate: false
    };
  },
  created() {
    this.getInfoFun();
  },
  computed: {
    dataRule() {
      return {
        policyNo: [{
          required: true,
          message: this.$t('请输入') + this.$t('保单号'),
          trigger: 'blur',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }, {
          min: 5,
          max: 200,
          message: this.$t('最少输入5字符') + '，' + this.$t('最多输入200字符'),
          trigger: 'blur',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('签约日期')
        }],
        endAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('终止日期')
        }],
        policyUrl: [{
          required: true,
          type: 'array',
          validator: this.validateImg,
          trigger: 'change'
        }]
      };
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  watch: {
    attachValue: {
      handler(newVal, oldVal) {
        let cloneTableData = cloneDeep(this.tableData);
        this.tableData = [];
        newVal && newVal.forEach(value => {
          let selectItem = cloneTableData.filter(item => item.attachId === value);
          if (!selectItem.length) {
            selectItem = this.attachOptions.filter(item => item.attachId === value);
          }
          if (selectItem.length) {
            let item = selectItem[0];
            if (!item.attachPlan) {
              //保障额度一个都没有的情况
              item.attachPlanId = '-';
              item.price = '-';
              item.amount = '-';
            } else {
              //默认选中第一个方案
              item.attachPlanId = item.attachPlanId || item.attachPlan[0].id;
              item.price = item.price || item.attachPlan[0].price;
              if (item.attachPlan.length === 1) {
                //只有一个方案的直接保障额度使用文本展示
                item.amount = item.amount || item.attachPlan[0].amount;
              }
            }
            this.tableData.push(item);
          }
        });
      }
    }
  },
  methods: {
    validateImg(rule, value, callback) {
      if (this.fileList.length == 0) {
        callback(new Error(this.$t('请上传电子保单')));
      } else {
        callback();
      }
    },
    async getInfoFun() {
      const res = await policyDetail({
        policyId: this.$route.params.id
      });
      this.policInfo = {
        customerName: res.baseInfo.customerName,
        applicationName: res.baseInfo.applicationName,
        insuranceName: res.policyInfo.insuranceName,
        unitName: res.policyInfo.unitName,
        agencyName: res.policyInfo.agencyName,
        intermediaryName: res.policyInfo.intermediaryName,
        insuranceCode: res.policyInfo.insuranceCode,
        waitTime: res.policyInfo.waitTime,
        insuranceSorName: res.policyInfo.insuranceSorName,
        planName: ''
      };
      const {
        policyNo,
        insuranceId,
        startAt,
        endAt,
        premium,
        planId,
        policyType,
        areaCode,
        discountMode,
        discountRatio,
        discountAmount,
        personnelDetails
      } = res.policyInfo;
      this.form = {
        policyId: this.$route.params.id,
        policyNo: policyNo,
        policyUrl: [],
        insuranceId: insuranceId,
        startAt: startAt,
        endAt: endAt,
        premiumPrice: premium,
        planId: planId,
        policyType: policyType,
        areaCode,
        discountMode,
        discountRatio,
        discountAmount,
        personnelDetails
      };
      let rate = res.baseInfo.rate;
      if (rate) {
        this.$set(this.form, 'rate', rate);
      }
      if (res.policyInfo.policyUrl.length != 0) {
        this.fileList = res.policyInfo.policyUrl.map((item, index) => {
          let obj = {
            url: item.url,
            uid: index + 1,
            name: item.name,
            status: 'done',
            type: item.format
          };
          return obj;
        });
      }
      this.generationTemplate(res); //生成干系人模板信息
      this.rendering = await policyRendering({
        insuranceId: this.form.insuranceId
      });
      const plan = await mainPlanResource({
        insuranceId: res.policyInfo.insuranceId
      });
      this.planList = plan.items.map(item => {
        item.rightsCont = JSON.parse(item.rights);
        return item;
      });
      const planInfo = this.planList.filter(item => item.id == this.form.planId)[0];
      this.handlerAttachTemplate(res.policyInfo, planInfo); //处理附加险回显信息
      this.policInfo.planName = planInfo.name + '-' + this.$t('保障额度') + planInfo.amount + this.$t(this.i18nCurrencyUnit(this.$store.state.user.accountInfo.customerId));
      this.policInfo.duration = planInfo.duration;
      this.handleAreaEcho(planInfo); //区域保费的区域回显
      const insuredInfo = await policyInsuredInfo({
        policyId: this.$route.params.id
      });
      this.handlerInsuredInfo(insuredInfo); //处理干系人的回显信息
      let that = this;
      setTimeout(() => {
        that.isShow = true;
      }, 400);
      // this.showPersonnelDetail = res.baseInfo.declarationMethod || false;
      this.giveAway(res, planInfo);
    },
    giveAway(res, planInfo) {
      //费率类型、赠险、人员明细逻辑
      let dayReg = /^(\d)*天/;
      this.showRate = res.baseInfo.declarationMethod && (planInfo.duration === '1年' || dayReg.test(planInfo.duration)) || false;
    },
    handleAreaEcho(planInfo) {
      //是否是区域保费
      if (!planInfo) return;
      this.isAreaPrice = planInfo.priceType === 'AREA_PRICE' ? true : false;
      this.priceMap = {};
      const formatShowArea = (data, price, parent) => {
        const result = data.map(item => {
          let obj = {};
          if (item.city && item.city.length) {
            obj.children = formatShowArea(item.city, item.price, item);
          }
          if (item.code === Number(this.form.areaCode)) {
            item.isSelectCode = true;
            if (parent) {
              parent.isSelectCode = true;
            }
          }
          if (item.isSelectCode) {
            this.codeValue.unshift(item.code);
          }
          this.priceMap[item.code] = price || item.price;
          obj.value = item.code;
          obj.label = item.name;
          return obj;
        });
        return result;
      };
      let allShowArea = planInfo.allShowArea ? JSON.parse(planInfo.allShowArea) : [];
      this.rearOptions = formatShowArea(allShowArea);
    },
    handlerInsuredInfo(insuredInfo) {
      insuredInfo.applicant.forEach(item => {
        if (item.code === 'applicantType') {
          this.$set(this.applicantForm, 'applicantType', item.valData);
        }
      });
      this.applicantList = insuredInfo.applicant.filter((item, index) => index != 0);
      this.applicantList = this.applicantList.map(item => {
        item.required = this.applicantRequireMap[item.code] || item.required || false;
        this.$set(this.applicantForm, item.code, item.valData || undefined);
        if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
          item.selectarr = this.applicantSelectValueMap[item.code];
        }
        return item;
      });
      this.insuredList = insuredInfo.insured;
      this.insuredList = this.insuredList.map((item, index) => {
        item = item.map(item2 => {
          item2.required = this.insuredRequireMap[item2.code] || item2.required || false;
          this.$set(this.insuredForm, item2.code + index, item2.valData);
          if (item2.display == 'dropDownBox' || item2.display == 'profession' || item2.display == 'dropDownBox(region.code)') {
            item2.selectarr = this.insuredSelectValueMap[item2.code];
          }
          return item2;
        });
        return item;
      });
    },
    handlerAttachTemplate(policyInfo, planInfo) {
      var _policyInfo$attachInf;
      //处理回显的附加险信息
      // policyInfo 已经选中的附加险数据
      //planInfo 全部的可选的附加险数据
      if (policyInfo !== null && policyInfo !== void 0 && (_policyInfo$attachInf = policyInfo.attachInfo) !== null && _policyInfo$attachInf !== void 0 && _policyInfo$attachInf.length) {
        this.hasAttachInfo = true;
        this.tableData = policyInfo.attachInfo;
        let attachValue = [];
        let buyLimitMap = {}; //是否必购以新建时候该附加险是否必购为主
        policyInfo.attachInfo.forEach(item => {
          attachValue.push(item.attachId);
          buyLimitMap[item.attachId] = item.buyLimit;
        });
        this.attachOptions = planInfo.attachInfo && JSON.parse(planInfo.attachInfo).map(item => {
          delete item.attachPlanId;
          delete item.price;
          let buyLimit = buyLimitMap[item.attachId] || item.buyLimit; //是否必购以新建时候该附加险是否必购为主
          if (buyLimit === 1) {
            item.disabled = true;
            item.allowClear = false;
          }
          return item;
        });
        this.attachValue = attachValue;
      }
    },
    generationTemplate(res) {
      //根据保险方案获取干系人的相关信息以及折扣的信息
      let templateRenderList = res.template;
      Array.isArray(templateRenderList) && templateRenderList.forEach(item => {
        if (item.code === 'applicant') {
          //投保人
          let applicantTypeInfo = item.item[0];
          let applicantInfo = [];
          if (applicantTypeInfo.inputKey === 'COMPANY') {
            applicantInfo = item.company;
          }
          if (applicantTypeInfo.inputKey === 'NATURAL_PERSON') {
            applicantInfo = item.personal;
          }
          this.applicantInfo = item; //投保人模板信息
          let mapValue = {};
          let selectValueMap = {};
          applicantInfo.forEach(item => {
            mapValue[item.code] = item.isOptional === 0;
            if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
              selectValueMap[item.code] = item.value;
            }
          });
          this.applicantRequireMap = mapValue;
          this.applicantSelectValueMap = selectValueMap;
          this.applicantTypeTemOption = applicantTypeInfo.value; //投保类型的选择模板数据
        }
        if (item.code === 'insured') {
          //被投保人
          let mapValue = {};
          let selectValueMap = {};
          item.item.forEach(item => {
            mapValue[item.code] = item.isOptional === 0;
            if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
              selectValueMap[item.code] = item.value;
            }
          });
          this.insuredSelectValueMap = selectValueMap;
          this.insuredRequireMap = mapValue;
          this.insuredTemplate = item.item; //存储模板，有新增被投保人的时候使用
        }
      });
    },
    formatFormTemplate(data) {
      if (!Array.isArray(data)) {
        return [];
      }
      return data.map(item => {
        let obj = {
          code: item.code,
          display: item.display,
          id: item.id,
          name: item.name,
          type: item.type,
          valData: undefined,
          selectarr: [],
          required: item.isOptional === 0
        };
        if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
          obj.selectarr = item.value;
        }
        return obj;
      });
    },
    handleChange(info) {
      let limitSize = 10 * 1024 * 1024;
      if (info.file.size > limitSize) {
        this.$message.error(this.$t('上传文件大小超过10M'));
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    async handlePreview(file) {
      if (file.type == 'application/pdf' || file.type == 'pdf') {
        window.open(file.url);
      } else {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
      }
    },
    applicantChange() {
      const arr = this.applicantForm.applicantType === 'COMPANY' ? this.applicantInfo.company : this.applicantInfo.personal;
      // this.form.insuranceType = this.applicantForm.applicantType;
      this.applicantForm && Object.keys(this.applicantForm).forEach(key => {
        if (key !== 'applicantType') {
          this.$delete(this.applicantForm, key);
          // this.applicantForm[key] = undefined;
        }
      });
      this.applicantList = this.formatFormTemplate(arr);
      // this.insuredList = [];
      // this.addInsuredFun();
    },
    async getSelectInfo(type, item, index, index2) {
      if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
        item.selectarr = [];
        let res = await policyTempConfig({
          insuranceId: this.form.insuranceId,
          tempCode: item.code
        });
        if (type == 'applicant') {
          this.applicantList[index].selectarr = res;
        } else {
          this.insuredList[index][index2].selectarr = res;
          this.insuredList[index][index2].selectarr;
        }
      }
    },
    selectArea(value, valueName, index, index2) {
      if (index2 != -1) {
        this.insuredList[index][index2].valData = valueName;
        this.insuredList[index][index2].defaultValue = value;
      } else {
        this.applicantList[index].valData = valueName;
        this.applicantList[index].defaultValue = value;
      }
    },
    addInsuredFun() {
      let arr = [];
      this.rendering.insured.map(item => {
        let obj = {
          code: item.code,
          display: item.display,
          id: item.id,
          name: item.name,
          type: item.type,
          valData: undefined,
          selectarr: item.selectarr
        };
        arr.push(obj);
      });
      this.insuredList.push(arr);
      this.insuredList.map((item, index) => {
        item.map((item2, index2) => {
          this.getSelectInfo('insured', item2, index, index2);
        });
      });
    },
    onSubmit() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          this.resultArr = [];
          this.checkForm(this.$refs.applicantForm);
          this.$refs.insuredForm && this.$refs.insuredForm.forEach(item => {
            this.checkForm(item);
          });
          Promise.all(this.resultArr).then(async () => {
            var _obj$policyNo;
            this.loading = true;
            this.applicantList = this.applicantList.map(item => {
              if (item.checkResult) {
                delete item.checkResult;
              }
              if (item.display === 'text') {
                var _item$valData;
                item.valData = ((_item$valData = item.valData) === null || _item$valData === void 0 ? void 0 : _item$valData.trim()) || '';
              }
              return item;
            });
            this.insuredList = this.insuredList.map(item => {
              return item.map(item2 => {
                if (item2.checkResult) {
                  delete item2.checkResult;
                }
                if (item2.display === 'text') {
                  var _item2$valData;
                  item2.valData = ((_item2$valData = item2.valData) === null || _item2$valData === void 0 ? void 0 : _item2$valData.trim()) || '';
                }
                return item2;
              });
            });
            const res = await policyVerifyy({
              insuranceId: this.form.insuranceId,
              applicant: this.applicantList,
              insured: this.insuredList
            }).finally(() => {
              this.loading = false;
            });
            this.applicantList = res.applicant;
            this.insuredList = res.insured;
            if (res.isCheck) {
              this.loading = false;
              return false;
            }
            let obj = this.form;
            obj.policyNo = ((_obj$policyNo = obj.policyNo) === null || _obj$policyNo === void 0 ? void 0 : _obj$policyNo.trim()) || '';
            let applicantList = recursionCopy(this.applicantList);
            let insuredList = recursionCopy(this.insuredList);
            applicantList.map(item => {
              if (item.selectarr) {
                delete item.selectarr;
              }
              return item;
            });
            insuredList.map(item => {
              item.map(item2 => {
                if (item2.selectarr) {
                  delete item2.selectarr;
                }
                return item2;
              });
              item;
            });
            obj.applicant = {
              applicantType: this.applicantForm.applicantType,
              list: [applicantList]
            };
            obj.insured = {
              list: insuredList
            };
            obj.policyUrl = this.fileList.map(item => {
              return item.url;
            });
            if (this.attachValue.length) {
              let isError = false;
              this.tableData.forEach(item => {
                if (item.attachPlanId === '-') {
                  isError = true;
                  this.$message.error(this.$t('所选附加险无可用额度'));
                }
              });
              if (isError) {
                this.loading = false;
                return;
              }
              obj.attachInfo = this.tableData;
            }
            if (obj.areaCode) {
              obj.premiumPrice = this.priceMap[obj.areaCode];
            } else {
              const planInfo = this.planList.filter(item => item.id == this.form.planId)[0];
              obj.premiumPrice = planInfo.price;
            }
            this.loading = true;
            editPolicy(obj).then(res => {
              this.loading = false;
              this.$message.success(this.$t('保存成功'));
              this.$router.go(-1);
            }).finally(() => {
              this.loading = false;
            });
          }, () => {
            this.loading = false;
          });
        }
      });
    },
    amountSelect(value, record) {
      let attachPLan = record.attachPlan && Array.isArray(record.attachPlan) && record.attachPlan.filter(item => item.id === value);
      if (attachPLan.length) {
        this.$set(record, 'price', attachPLan[0].price);
        this.$set(record, 'attachPlanId', value);
      }
      this.tableData = [...this.tableData];
    },
    timeChange(value) {
      //通过生效日期计算终止日期
      if (!value) {
        this.form.endAt = '';
        return;
      }
      let duration = this.policInfo.duration;
      let startTime;
      if (duration) {
        if (/-/.test(duration)) {
          duration = duration.split('-')[1];
        }
        if (/^[0-9]+年$/.test(duration)) {
          duration = Number.parseInt(duration);
          startTime = new Date(value).getTime() + duration * 365 * 24 * 60 * 60 * 1000;
        }
        if (/^[0-9]+月$/.test(duration)) {
          duration = Number.parseInt(duration);
          startTime = new Date(value).getTime() + duration * 30 * 24 * 60 * 60 * 1000;
        }
        if (/^[0-9]+天$/.test(duration)) {
          duration = Number.parseInt(duration);
          startTime = new Date(value).getTime() + duration * 24 * 60 * 60 * 1000;
        }
        if (duration === '终身') {
          startTime = new Date(value).getTime() + 100 * 365 * 24 * 60 * 60 * 1000;
        }
      }
      this.form.endAt = moment(startTime).format('YYYY-MM-DD HH:mm:ss');
      this.form.startAt = moment(value).format('YYYY-MM-DD HH:mm:ss');
      this.$refs.dataFrom.validateField('endAt');
    },
    getErrorMessage(item) {
      //区分校验的报错信息
      if (item.display === 'text') {
        return this.$t('请填写') + item.name;
      } else {
        return this.$t('请选择') + item.name;
      }
    },
    asyncValue(e, obj, key, type) {
      if (type === 'select') {
        this.$set(obj, key, e);
      } else {
        this.$set(obj, key, e.target.value);
      }
    },
    checkForm(form) {
      let result = new Promise((resolve, reject) => {
        form.validate(valid => {
          if (valid) {
            resolve();
          } else {
            reject(valid);
          }
        });
      });
      this.resultArr.push(result);
    }
  }
};